import { UNIT_LABELS, type UnitCounts, type UnitKey } from '../api/types';

/** Zeigt nur die Einheitentypen, die im Bericht überhaupt vorkommen. */
export function UnitList({ counts }: { counts: UnitCounts | null }) {
  if (!counts) return <span className="muted">—</span>;

  const present = (Object.entries(counts) as Array<[UnitKey, number]>).filter(
    ([, count]) => count > 0,
  );
  if (present.length === 0) return <span className="muted">keine</span>;

  return (
    <span className="unit-list">
      {present.map(([key, count]) => (
        <span key={key} className="unit-chip">
          {UNIT_LABELS[key]} <strong>{count.toLocaleString('de-DE')}</strong>
        </span>
      ))}
    </span>
  );
}
